import { dateFormat } from '@constants/dateFormat'
import { loadingWindows } from '@constants/orderDispatch'
import moment from 'moment'

export function doesLoadingWindowPass(rowLoadStartTime: string, rowLoadEndTime: string, selectedOptions: any) {
  const now = moment().local()
  const nowString = now.format(dateFormat.DATE)
  const sevenPmFormat = moment(`${nowString}' 7:00 PM'`).local()
  const sevenToday = sevenPmFormat.format(dateFormat.DATE_TIME)
  const oneAMFormat = moment(`${nowString}' 01:00 AM'`).add(1, 'days').local()
  const oneAMTomorrow = oneAMFormat.format(dateFormat.DATE_TIME)
  const loadWindowEnd = moment(rowLoadEndTime)
  const loadWindEndString = loadWindowEnd.format(dateFormat.DATE_TIME)
  const loadWindowStart = moment(rowLoadStartTime)
  const loadWindowStartString = loadWindowStart.format(dateFormat.DATE_TIME)

  switch (selectedOptions) {
    case loadingWindows.NOW:
      return now > loadWindowEnd
    case loadingWindows.BEFORESIX:
      return loadWindowEnd >= now && loadWindEndString <= sevenToday
    case loadingWindows.BEFOREMIDNIGHT:
      return loadWindowEnd >= now && loadWindEndString <= oneAMTomorrow && loadWindEndString > sevenToday
    case loadingWindows.AFTERMIDNIGHT:
      return loadWindowStart >= now && loadWindowStartString <= oneAMTomorrow && loadWindowStartString > sevenToday
    default:
      return true
  }
}
